module.exports = __webpack_public_path__ + "media/images/flags/eu-db2e50ad0bf5ecccc0caf01d1556a162.svg";